import { Grid, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import SvgConverter from '../../../common/SvgConverter';
import LabelWithIcon from '../../../common/ui/LabelWithIcon';
import FormInput from '../../../common/ui/Forms/FormInput/FormInput';
import CustomButton from '../../../common/ui/CustomButton';
import { useForm } from 'react-hook-form';
import CustomSelectBox from '../../../common/ui/Selectbox/CustomSelect';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { APP_ROUTES } from '../../../common/constants/Routes';
import { useLocation, useNavigate } from 'react-router-dom';
import { bloodGroup, gender } from '../../../common/constants/dropDownList';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

const VolunteerForm = ({
  text,
  handleSubmit,
  register,
  reset,
  errors,
  control,
  setValue,
}: {
  text: any;
  handleSubmit: any;
  register: any;
  reset: any;
  errors: any;
  control: any;
  setValue: any;
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const onSubmit = (data: any) => {
   
    // console.log(data?.userName);
    navigate(APP_ROUTES.VOLUNTEER);
  };
  return (
    <Grid>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid
          container
          display='flex'
          justifyContent='center'
          // className='login-form'
        >
          <Grid container xs={12} p={2}>
            <Grid item xs={6} alignItems={'center'} display={'flex'}>
              <Typography
                fontSize={20}
                fontWeight={600}
                color={theme.palette.info.dark}
              >
                {text}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              alignItems={'center'}
              justifyContent={'flex-end'}
              display={'flex'}
            >
              <CustomButton
                type='button'
                text='Go Back'
                startIcon={SubdirectoryArrowRightIcon}
                color={'primary'}
                className='p-8 color-gray'
                onClick={() => {
                  navigate(APP_ROUTES.VOLUNTEER);
                }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6} p={2}>
            <LabelWithIcon
              label={'First Name'}
              justifyContent='flex-start'
              className='mb-6  '
            />
            <FormInput
              name='firstName'
              type='text'
              placeholder='First Name..'
              control={control}
              className='input-from'
              rules={{
                required: {
                  value: true,
                  message: 'Please enter a First Name',
                },
              }}
              inputProps={{
                ...register('firstName', {}),
              }}
              errors={errors}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6} p={2}>
            <LabelWithIcon
              label={'Last Name'}
              justifyContent='flex-start'
              className='mb-6 '
            />
            <FormInput
              name='lastName'
              type='text'
              placeholder='Last Name..'
              control={control}
              className='input-from'
              rules={{
                required: {
                  value: true,
                  message: 'Please enter a lastName',
                },
              }}
              inputProps={{
                ...register('lastName', {}),
              }}
              errors={errors}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6} p={2}>
            <LabelWithIcon
              label={'Email'}
              justifyContent='flex-start'
              className='mb-6 '
            />
            <FormInput
              name='email'
              type='text'
              placeholder='Email..'
              control={control}
              className='input-from'
              rules={{
                required: {
                  value: true,
                  message: 'Please enter a Email',
                },
              }}
              inputProps={{
                ...register('email', {}),
              }}
              errors={errors}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6} p={2}>
            <LabelWithIcon
              label={'Mobile number'}
              justifyContent='flex-start'
              className='mb-6 '
            />
            <FormInput
              name='contact'
              type='text'
              placeholder='Mobile..'
              control={control}
              className='input-from'
              rules={{
                required: {
                  value: true,
                  message: 'Please enter a  Mobile number',
                },
              }}
              inputProps={{
                ...register('contact', {}),
              }}
              errors={errors}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6} p={2}>
            <LabelWithIcon
              label={'Gender'}
              justifyContent='flex-start'
              className='mb-6 '
            />
            <CustomSelectBox
              options={gender}
              ClassName='form-select'
              placeholder={'gender'}
              inputProps={register('gender', {
                required: {
                  value: true,
                  message: 'select the gender',
                },
              })}
              name={'gender'}
              error={errors}
              defaultValue={location.state?.data?.gender}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6} p={2}>
            <LabelWithIcon
              label={'DOB'}
              justifyContent='flex-start'
              className='mb-6 '
            />
            <FormInput
              name='dob'
              type='date'
              placeholder='First Name..'
              control={control}
              className='input-from'
              rules={{
                required: {
                  value: true,
                  message: 'Please enter DOB',
                },
              }}
              inputProps={{
                ...register('dob', {}),
              }}
              errors={errors}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6} p={2}>
            <LabelWithIcon
              label={'Blood Group'}
              justifyContent='flex-start'
              className='mb-6 '
            />
            <CustomSelectBox
              options={bloodGroup}
              ClassName='form-select'
              placeholder={'Blood group'}
              name={'bloodGroup'}
              inputProps={register('bloodGroup', {
                required: {
                  value: true,
                  message: 'select the blood group',
                },
              })}
              error={errors}
              defaultValue={location.state?.data?.bloodGroup}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6} p={2}>
            <LabelWithIcon
              label={'Address'}
              justifyContent='flex-start'
              className='mb-6 '
            />
            <FormInput
              hideCountButton
              multipleLine
              name='address'
              type='text'
              placeholder='address..'
              control={control}
              className='input-from-text'
              rules={{
                required: {
                  value: true,
                  message: 'Please enter a address',
                },
              }}
              inputProps={{
                ...register('address', {}),
              }}
              errors={errors}
            />
          </Grid>
          <Grid item xs={12} justifyContent='flex-end' display={'flex'} my={5}>
            <CustomButton
              type='button'
              text='reset'
              // startIcon={ArrowBackIcon}
              color={'primary'}
              className='p-12 mx-10 color-gray'
              onClick={() => {
                reset();
              }}
            />
            <CustomButton
              type='submit'
              // startIcon={AddIcon}
              text='Save volunteer'
              color={'warning'}
              className='p-12'
            />
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
};

export default VolunteerForm;
